export const AJS_ANONYMOUS_ID = 'ajs_anonymous_id'
export const UNIVERSAL_ID = 'universal_id'
